import phones from "../../images/phones.png";
import iosImg from "../../images/iosImg.svg";
import classes from "./DownloadApp.module.css";
import whiteLogo from "../../images/sidebar/Logo.svg";
import androidImg from "../../images/androidImg.svg";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";

export function DownloadApp() {
  const { t } = useTranslations();

  const text = t.downloadAppModal;

  return (
    <section className={`${classes.container} fadeIn`}>
      <div className={classes.content}>
        <img src={whiteLogo} className={classes.logo} />

        <div className={classes.card}>
          <div className={classes.cardContent}>
            <h2>{text.heading}</h2>
            <p>
              {text.checkEmail} <br />
              {text.andDownload}
            </p>
            <div className={classes.buttons}>
              <button>
                <img src={iosImg} />
              </button>
              <button>
                <img src={androidImg} />
              </button>
            </div>
          </div>
          <img src={phones} className={classes.phones} />
        </div>
      </div>
    </section>
  );
}
